import { createTheme } from "@mui/material/styles";

// Public site theme - only used for notifications & spinners; the site itself is styled in css/site.css
const theme = createTheme({
  palette: {
    primary: {
      main: "#2E3238",
      contrastText: "#fff",
    },
    secondary: {
      main: "#3F5C58",
      contrastText: "#fff",
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#2E3238",
    },
  },
  typography: {
    fontFamily: "\"Questrial\", Arial, sans-serif",
  },
});

export default theme;
